module.exports = __webpack_public_path__ + "img/top-catchcopy-6.7c753480.png";